import { IMultiLanguageValue } from '../../../common/interfaces/MultiLanguageValue.interface';
import { BroadcastType } from '../../../common/enums/BroadcastType';

/**
 * Builds FormData for broadcast creation API
 */
export const buildBroadcastFormData = (params: {
  file: File;
  scheduledAt: Date;
  title: IMultiLanguageValue[];
  body: IMultiLanguageValue[];
  messageTitle: IMultiLanguageValue[];
  messageBody: IMultiLanguageValue[];
  type?: BroadcastType;
  mediaId?: string;
  deepLink?: string;
  screenName?: string;
  ctaText?: IMultiLanguageValue[];
  externalUrl?: string;
}): FormData => {
  const formData = new FormData();

  formData.append('file', params.file);
  formData.append('scheduledAt', params.scheduledAt.toISOString());
  formData.append('title', JSON.stringify(params.title));
  formData.append('body', JSON.stringify(params.body));
  formData.append('messageTitle', JSON.stringify(params.messageTitle));
  formData.append('messageBody', JSON.stringify(params.messageBody));

  if (params.type) {
    formData.append('type', params.type);
  }

  if (params.mediaId) {
    formData.append('mediaId', params.mediaId);
  }

  if (params.deepLink) {
    formData.append('deepLink', params.deepLink);
  }

  if (params.screenName) {
    formData.append('screenName', params.screenName);
  }

  if (params.ctaText && params.ctaText.length > 0) {
    formData.append('ctaText', JSON.stringify(params.ctaText));
  }

  if (params.externalUrl) {
    formData.append('externalUrl', params.externalUrl);
  }

  return formData;
};
